export default class LoginFormErrors {
  auth = {
    login: null,
    password: null
  }

  authRequirements = []

  captcha = {
    resolve: null,
    token: null,
    type: null
  }

  captchaRequirements = []

  user = {
    blocked: null,
    password: null
  }

  constructor (object) {
    const auth = object?.auth ?? {}
    let authKey = Array.isArray(auth) ? 'authRequirements' : 'auth'

    const captcha = object?.captcha ?? {}
    let captchaKey = Array.isArray(captcha) ? 'captchaRequirements' : 'captcha'
    Object.assign(this[captchaKey], captcha)

    Object.assign(this[authKey], auth)
    Object.assign(this.user, object?.user ?? {})
  }
}
